/* Kyriacou Cosmetics — theme behaviour (no dependencies) */
(() => {
  const KC = (window.KC = window.KC || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const routes = (window.KCConfig && window.KCConfig.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', cart_update_url: '/cart/update' };

  /* ---------- drawers (menu, cart) ---------- */
  let lastFocus = null;
  KC.openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 60);
  };
  KC.closeDrawer = (d) => {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.kc-drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) { e.preventDefault(); KC.openDrawer(open.getAttribute('data-open-drawer')); return; }
    const close = e.target.closest('[data-close-drawer]');
    if (close) { e.preventDefault(); KC.closeDrawer(close.closest('.kc-drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.kc-drawer.is-open').forEach(KC.closeDrawer);
    const s = $('.kc-search.is-open'); if (s) KC.toggleSearch(false);
  });

  /* ---------- search overlay ---------- */
  KC.toggleSearch = (on) => {
    const s = $('#kc-search'); if (!s) return;
    s.classList.toggle('is-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) setTimeout(() => { const i = s.querySelector('input'); i && i.focus(); }, 50);
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); KC.toggleSearch(true); }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); KC.toggleSearch(false); }
  });

  /* ---------- sticky header shadow ---------- */
  const header = $('.kc-header');
  if (header) {
    const setH = () => document.documentElement.style.setProperty('--kc-header-h', header.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- money ---------- */
  KC.money = (cents) => {
    const fmt = (window.KCConfig && window.KCConfig.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas).replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + d).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, i + ',' + d);
  };

  /* ---------- toast ---------- */
  KC.toast = (msg) => {
    let t = $('.kc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'kc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(KC._toastT); KC._toastT = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- cart ---------- */
  const drawerSectionId = 'kc-cart-drawer';
  KC.renderCartSections = async (sections) => {
    if (sections && sections[drawerSectionId]) {
      const html = new DOMParser().parseFromString(sections[drawerSectionId], 'text/html');
      const fresh = html.querySelector('#kc-cart-drawer-inner');
      const cur = $('#kc-cart-drawer-inner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    if (sections && sections['kc-main-cart']) {
      const html = new DOMParser().parseFromString(sections['kc-main-cart'], 'text/html');
      const fresh = html.querySelector('#kc-main-cart'); const cur = $('#kc-main-cart');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    KC.loadRecs();
    return cart;
  };
  const sectionsParam = () => [drawerSectionId, $('#kc-main-cart') ? 'kc-main-cart' : null].filter(Boolean).join(',');

  KC.addToCart = async (form, btn) => {
    const fd = new FormData(form);
    fd.append('sections', sectionsParam());
    fd.append('sections_url', window.location.pathname);
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) { KC.toast(data.description || data.message || 'Could not add to bag'); return; }
      await KC.renderCartSections(data.sections);
      if (!document.body.classList.contains('template-cart')) KC.openDrawer('kc-cart');
      else KC.toast('Added to bag');
    } catch (e) { KC.toast('Could not add to bag'); }
    finally { btn && btn.classList.remove('is-loading'); }
  };

  KC.changeLine = async (key, quantity) => {
    const scope = $('#kc-cart-drawer-inner'); scope && scope.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionsParam(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { KC.toast(data.description || 'Could not update bag'); }
      await KC.renderCartSections(data.sections);
    } finally { const s = $('#kc-cart-drawer-inner'); s && s.classList.remove('is-loading'); }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-kc-add]');
    if (!form) return;
    e.preventDefault();
    KC.addToCart(form, form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      const line = step.closest('[data-line-key]'); const input = line.querySelector('input[data-line-qty]');
      const q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(step.getAttribute('data-line-step'), 10));
      KC.changeLine(line.getAttribute('data-line-key'), q); return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); KC.changeLine(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[data-line-qty]');
    if (input) KC.changeLine(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, parseInt(input.value || '0', 10)));
    const note = e.target.closest('textarea[name="note"][data-cart-note]');
    if (note) fetch(routes.cart_update_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* cart drawer recommendations (based on the first line item) */
  KC.loadRecs = async () => {
    const box = $('[data-cart-recs]'); if (!box) return;
    const pid = box.getAttribute('data-product-id'); if (!pid) { box.innerHTML = ''; return; }
    try {
      const url = `${(window.KCConfig && window.KCConfig.routes.product_recommendations_url) || '/recommendations/products'}?product_id=${pid}&limit=6&section_id=kc-cart-recs`;
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recs-inner]');
      box.innerHTML = inner && inner.children.length ? inner.outerHTML : '';
    } catch (e) { box.innerHTML = ''; }
  };
  document.addEventListener('DOMContentLoaded', KC.loadRecs);

  /* ---------- product form: variants, qty, gallery ---------- */
  const initProduct = (root) => {
    const dataEl = root.querySelector('script[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = root.querySelector('form[data-kc-add]');
    const idInput = form && form.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const btn = form && form.querySelector('[type="submit"]');
    const btnLabel = btn && btn.querySelector('[data-btn-label]');
    const sticky = $('.kc-sticky-atc');

    const currentOptions = () => $$('[data-option-index]', root).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const update = () => {
      const opts = currentOptions();
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) { if (btn) { btn.disabled = true; btnLabel && (btnLabel.textContent = btn.dataset.unavailable); } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        let html = KC.money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) html += ` <s>${KC.money(v.compare_at_price)}</s>`;
        priceEl.innerHTML = html;
      }
      if (btn) { btn.disabled = !v.available; btnLabel && (btnLabel.textContent = v.available ? btn.dataset.add : btn.dataset.soldout); }
      if (v.featured_media) showSlide(root, v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
    };
    $$('[data-option-index] input', root).forEach((i) => i.addEventListener('change', update));

    // qty
    root.addEventListener('click', (e) => {
      const s = e.target.closest('[data-qty-step]'); if (!s) return;
      e.preventDefault();
      const input = s.parentElement.querySelector('input'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
    });

    // sticky add to cart
    if (sticky && btn) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(btn);
      const sbtn = sticky.querySelector('[data-sticky-add]');
      sbtn && sbtn.addEventListener('click', (e) => { e.preventDefault(); KC.addToCart(form, sbtn); });
    }
  };
  const showSlide = (root, mediaId) => {
    const slides = $$('[data-media-id]', root); if (!slides.length) return;
    slides.forEach((s) => s.classList.toggle('is-active', String(s.dataset.mediaId) === String(mediaId)));
    $$('[data-thumb-for]', root).forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumbFor) === String(mediaId) ? 'true' : 'false'));
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb-for]'); if (!t) return;
    e.preventDefault(); showSlide(t.closest('[data-product-root]'), t.dataset.thumbFor);
  });
  $$('[data-product-root]').forEach(initProduct);

  /* ---------- product page recommendations ---------- */
  const loadProductRecs = (root = document) => {
    $$('[data-recs-url]', root).forEach(async (el) => {
      if (el.dataset.loaded) return; el.dataset.loaded = '1';
      try {
        const html = await fetch(el.dataset.recsUrl).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recs-url]');
        if (fresh) el.innerHTML = fresh.innerHTML;
      } catch (e) { /* leave empty */ }
    });
  };
  loadProductRecs();

  /* ---------- collection filters (auto submit + mobile panel) ---------- */
  const filterForm = $('#kc-filters-form');
  if (filterForm) {
    let t;
    filterForm.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => KC.applyFilters(), 250); });
    filterForm.addEventListener('submit', (e) => { e.preventDefault(); KC.applyFilters(); });
  }
  KC.applyFilters = async (url) => {
    const form = $('#kc-filters-form');
    if (!url) {
      const params = new URLSearchParams(new FormData(form));
      const sort = $('#kc-sort'); if (sort && sort.value) params.set('sort_by', sort.value);
      for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
      url = `${window.location.pathname}?${params.toString()}`;
    }
    const grid = $('#kc-collection'); grid && grid.classList.add('is-loading');
    try {
      const html = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + grid.dataset.sectionId).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#kc-collection');
      if (fresh) grid.replaceWith(fresh);
      window.history.replaceState({}, '', url);
      initFiltersUI();
    } catch (e) { window.location.href = url; }
  };
  const initFiltersUI = () => {
    const sort = $('#kc-sort');
    if (sort) sort.addEventListener('change', () => KC.applyFilters());
    const f = $('#kc-filters-form');
    if (f && !f.dataset.bound) { f.dataset.bound = '1'; let t; f.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => KC.applyFilters(), 250); }); f.addEventListener('submit', (e) => { e.preventDefault(); KC.applyFilters(); }); }
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-filter-link]');
    if (a) { e.preventDefault(); KC.applyFilters(a.getAttribute('href')); return; }
    const tg = e.target.closest('[data-toggle-filters]');
    if (tg) { e.preventDefault(); const aside = $('.kc-coll__aside'); aside && aside.classList.toggle('is-open'); }
  });
  initFiltersUI();

  /* ---------- newsletter success ---------- */
  if (window.location.search.includes('customer_posted=true')) KC.toast('Thank you — you are on the list.');

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.kc-reveal').forEach((el) => io.observe(el));
  } else { $$('.kc-reveal').forEach((el) => el.classList.add('is-in')); }

  /* ---------- theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product-root]', e.target).forEach(initProduct);
    loadProductRecs(e.target);
    $$('.kc-reveal', e.target).forEach((el) => el.classList.add('is-in'));
    initFiltersUI();
  });
})();